import _ from "lodash";
import { useContext } from "react";

import LaunchDarklyContext from "./launchDarklyProvider";

export const useFlags = () => {
  const { flags } = useContext(LaunchDarklyContext);

  return _.mapKeys(flags, (v, k) => _.camelCase(k));
};
